const DESIGNATIONS_ROUTE = '/designations'

export { DESIGNATIONS_ROUTE }
